import React from 'react';
import styled from 'styled-components';
import { Container, CompletionCard, CenteredContainer, T1, Description } from '../../styles/SurveyStyles';

const ActionButton = styled.button`
  background-color: ${props => props.themeColors?.buttonColor || '#007bff'};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  margin-top: 20px;
  cursor: pointer;
  font-weight: bold;
  
  &:hover {
    opacity: 0.9;
  }
`;

const SurveyError = ({ themeColors, errorMessage, onRetry }) => {
  return (
    <Container themeColors={themeColors}>
      <CompletionCard>
        <CenteredContainer>
          <T1>Error Loading Survey</T1>
          <Description>{errorMessage}</Description>
          <ActionButton 
            onClick={onRetry} 
            themeColors={themeColors}>
            Try Again
          </ActionButton>
        </CenteredContainer>
      </CompletionCard>
    </Container>
  );
};

export default SurveyError; 